// extracted by mini-css-extract-plugin
module.exports = {"modalButtons":"Modal_modalButtons__1zePX","buttons":"Modal_buttons__3IY1F","modal":"Modal_modal__1Q2IY","close":"Modal_close__iJGrr"};